import { MenuItemWithBadge, SubmenuItem } from "Components/Core/Sidebar/subMenus";

export const subMenuConfig = {
  get config(): SubmenuItem[] {
    const config = [
      {
        label: <MenuItemWithBadge label={`Public`} />,
        link: "public",
      },
      {
        label: <MenuItemWithBadge label={`Private`} />,
        link: "private",
      },
    ];

    return config;
  },
};
